module.exports = __webpack_public_path__ + "static/media/ripp.b639078f.png";